import { SystemUsersTableWrapper } from '../components';

function SystemUsers() {
  return <SystemUsersTableWrapper />;
}

export { SystemUsers };
